import { useNavigate, useLocation } from 'react-router-dom';
import { useDataContext } from '../data/DataContext';

function AdminButton() {
  const { isAdmin, isInAdminMode, toggleAdminMode } = useDataContext();
  const navigate = useNavigate();
  const location = useLocation();

  const handleAdminSwitch = () => {
    if (isInAdminMode) {
      navigate('/trips');
    } else {
      navigate('/admin');
    }
    toggleAdminMode();
  };

  // Null statt false soll zurückgegeben werden, wenn der User keine Admin-Rechte hat
  return isAdmin ? (
    <button onClick={handleAdminSwitch} className='admin-button'>
      {isInAdminMode ? 'Zu User wechseln' : 'Zu Admin wechseln'}
    </button>
  ) : null;
}

export default AdminButton;